import { render, staticRenderFns } from "./importWaybill.vue?vue&type=template&id=355c1956&scoped=true"
import script from "./importWaybill.vue?vue&type=script&lang=js"
export * from "./importWaybill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c1956",
  null
  
)

export default component.exports